import { TFunction } from 'i18next';
import { TableColumn } from 'react-data-table-component';
import { NavigateFunction } from 'react-router';
import { User } from 'src/api/wa/store/WaUserStore';
import LinkButton from 'src/ui/wards/common/button/LinkButton';
import { WaScreensMap } from 'src/ui/wards/router/WardsScreenMap';
import { wardsNavigate } from 'src/ui/wards/router/WardsScreenRegistration';
import { WA_Screen } from 'src/ui/wards/router/WardsScreens';

export const userColumns = (
  navigate: NavigateFunction,
  t: TFunction<'translation', undefined>,
  setUser: (user: User | null) => void
): TableColumn<User>[] => {
  return [
    {
      name: t('wards.desktop.userSearch.userName'),
      cell: (row) => (
        <LinkButton
          title={row.name}
          onClick={() => {
            setUser(row);
            wardsNavigate(navigate, WaScreensMap[WA_Screen.UnadressedWorkplacesList].path, true);
          }}
        />
      ),
      grow: 1,
    },
    {
      name: t('wards.desktop.userSearch.ldapId'),
      cell: (row) => <div className="items-start ps-2">{row.ldapId}</div>,
      grow: 1,
    },
    {
      name: t('wards.desktop.userSearch.phoneNo'),
      cell: (row) => <div className="items-start ps-2">{row.telephoneNumber}</div>,
      grow: 1,
    },
    {
      name: t('wards.desktop.userSearch.organizationCode'),
      cell: (row) => <div className="items-start ps-2">{row.organizationCode}</div>,
      grow: 2,
    },
    {
      name: t('wards.desktop.userSearch.position'),
      cell: (row) => <div className="items-start ps-2">{row.positionName}</div>,
      grow: 1,
    },
  ];
};
